/* eslint-disable */
import ClientLayout from '@/components/client/layout/Index'
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import MainTab from './MainTab'
import CertificateTab from './CertificateTab'
import SubscriptionTab from './SubscriptionTab'
import TermsTab from './TermsTab'
import ValuesAndStrategiesTab from './ValuesAndStrategiesTab'
import GoalsAndAudienceTab from './GoalsAndAudienceTab'
import TechnicalRequirementsTab from './TechnicalRequirementsTab'
import WhyChooseUsTab from './WhyChooseUsTab'
import PrivacyPolicyTab from './PrivacyPolicyTab'
import VideoTab from './VideoTab'
import ElearningPolicyTab from './ElearningPolicyTab'
import { Box, Tabs } from '@mantine/core'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useMediaQuery } from '@mantine/hooks'

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const AboutUsPageContent = () => {
  const { t, lang } = useTranslation('client')
  const router = useRouter()
  const { query } = router
  const [currentTab, setCurrentTab] = useState(Number(query?.tab) || 0)
  const isMobile = useMediaQuery('(max-width: 755px)')

  useEffect(() => {
    const activeTab = query.tab
    setCurrentTab(Number(activeTab))
    // Use activeTab to set the initial active tab if needed
  }, [query])

  const handleTabChange = index => {
    // Update the URL with the active tab query parameter
    const { pathname } = router
    const newQuery = { ...router.query, tab: index }
    const newUrl = `${pathname}?${new URLSearchParams(newQuery).toString()}`
    window.history.replaceState({}, '', newUrl)
    setCurrentTab(index)
  }

  const tabs = [
    t('companyDetails'),
    t('valuesAndStrategies'),
    t('goalsAndAudience'),
    t('whyChooseUs'),
    t('technicalRequirements'),
    t('certificateOfAttendanceRegisterAttendance'),
    t('subscriptionAndPaymentPolicy'),
    t('termsAndConditions'),
    t('privacyPolicy'),
    t('guideOnHowToUse'),
    t('elearningPolicy'),
  ]

  return (
    // <ClientLayout>
    //   <NextSeo nofollow noindex />

    //   <Head>
    //     <title>{t('aboutUsPageTitle')}</title>
    //   </Head>

    <main className="max-w-screen-xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8 mt-4">
      <Box className="mt-[0px] p-16 pb-16 md:px-32 popover-bg rounded mb-6">
        <h1 className="text-2xl font-extrabold tracking-tight text-gray sm:text-3xl mt-4  ">
          {<p>{tabs[currentTab]}</p>}
        </h1>
      </Box>
      <Tabs
        orientation={isMobile ? 'horizontal' : 'vertical'}
        // variant="pills"
        active={currentTab || 0}
        onTabChange={handleTabChange}
        styles={theme => ({
          tabControl: {
            fontWeight: 'bold',

            fontSize: theme.fontSizes.md,
          },

          ...(isMobile && {
            tabsList: {
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'start',
            },
          }),

          tabActive: {
            backgroundColor: '#2a7996',
            color: '#fff !important',
          },
        })}
      >
        <Tabs.Tab
          className={classNames(
            currentTab == t('companyDetails')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('companyDetails')}
          style={{ fontWeight: 500 }}
        >
          <MainTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('valuesAndStrategies')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('valuesAndStrategies')}
          style={{ fontWeight: 500 }}
        >
          <ValuesAndStrategiesTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('goalsAndAudience')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('goalsAndAudience')}
          style={{ fontWeight: 500 }}
        >
          <GoalsAndAudienceTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('whyChooseUs')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('whyChooseUs')}
          style={{ fontWeight: 500 }}
        >
          <WhyChooseUsTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('technicalRequirements')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('technicalRequirements')}
          style={{ fontWeight: 500 }}
        >
          <TechnicalRequirementsTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('certificateOfAttendanceRegisterAttendance')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('certificateOfAttendanceRegisterAttendance')}
          style={{ fontWeight: 500 }}
        >
          <CertificateTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('subscriptionAndPaymentPolicy')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('subscriptionAndPaymentPolicy')}
          style={{ fontWeight: 500 }}
        >
          <SubscriptionTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('termsAndConditions')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('termsAndConditions')}
          style={{ fontWeight: 500 }}
        >
          <TermsTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('privacyPolicy')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('privacyPolicy')}
          style={{ fontWeight: 500 }}
        >
          <PrivacyPolicyTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('guideOnHowToUse')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('guideOnHowToUse')}
          style={{ fontWeight: 500 }}
        >
          <VideoTab />
        </Tabs.Tab>

        <Tabs.Tab
          className={classNames(
            currentTab == t('elearningPolicy')
              ? 'bg-teal-50 border-primary text-secondary hover:bg-teal-50 hover:text-secondary'
              : 'border-transparent text-gray-900 ',
            'group border-l-4 px-3 py-2 flex gap-2 items-center text-sm font-medium w-full focus-ring cursor-pointer',
          )}
          label={t('elearningPolicy')}
          style={{ fontWeight: 500 }}
        >
          <ElearningPolicyTab />
        </Tabs.Tab>
      </Tabs>
    </main>
    // </ClientLayout>
  )
}

export default AboutUsPageContent
